import { render, staticRenderFns } from "./sea-button.vue?vue&type=template&id=24e96c8e&"
import script from "./sea-button.vue?vue&type=script&lang=js&"
export * from "./sea-button.vue?vue&type=script&lang=js&"
import style0 from "./sea-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports